import { Select, Tooltip } from "antd";
import DatePicker from "../../../Common/DatePicker";
import React from "react";

const { Option } = Select;

export const FilterItem = ({
                        item,
                        handleFilter,
                        selections,
                        setTopFilters,
                        topFilters,
                        setDeselectionDate,
                    }) => {
    const removeFilter = (filterName) => {
        setDeselectionDate(filterName);
    };

    if (item.type === "date") {
        const dateFilter = topFilters?.find(({ name }) => name === item.name);

        return (
            <div className="filter-item filter-item--large">
                <Tooltip title={item.name} placement="topLeft">
                    <label>{item.name}</label>
                </Tooltip>
                <DatePicker
                    horisontal={true}
                    name={item.name}
                    filter={dateFilter}
                    setFilters={setTopFilters}
                    selectedDateField={item}
                    topFilter={true}
                    removeFilter={removeFilter}
                />
            </div>
        );
    }

    return (
        <div className="filter-item">
            <Tooltip title={item.name} placement="topLeft">
                <label>{item.name}</label>
            </Tooltip>
            <Select
                id={`select-${item.name.replace(/\s+/g, "-")}`}
                mode="multiple"
                size={"middle"}
                aria-multiselectable={"false"}
                dropdownStyle={{ width: "fit-content", minWidth: "100px" }}
                placeholder={`Select ${item.name}`}
                style={{ width: "100%" }}
                value={selections[item.name]?.values || []}
                onChange={(value) => handleFilter(item, value)}
                allowClear
                showSearch
                filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                }
                maxTagCount={0}
            >
                {item?.values?.map((option, i) => (
                    <Option key={i} value={option.value}>
                        {option.value +
                            (option.count ? ` (${option.count})` : "")}
                    </Option>
                ))}
            </Select>
        </div>
    );
};

